export const toCustomerOrdersErrorMessage = (status: number, payload: unknown) => {
  if (payload && typeof payload === 'object') {
    const message = (payload as { message?: unknown }).message
    if (typeof message === 'string' && message.trim()) {
      return message.trim()
    }
  }

  if (status === 400) return 'Richiesta ordini non valida'
  if (status === 401) return 'Sessione cliente non valida'
  if (status === 403) return 'Account non autorizzato per ordini cliente'
  if (status === 404) return 'Ordine non trovato'
  if (status === 503) return 'Servizio ordini non raggiungibile'
  if (status === 504) return 'Timeout servizio ordini'
  return 'Errore area ordini cliente'
}

export class CustomerOrdersApiError extends Error {
  status: number

  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}
